export default "__VITE_ASSET__928fce11__"